import React from "react";
import PropTypes from "prop-types";
import { BaasicButton, BaasicDropdown } from 'core/components';
import { defaultTemplate } from "core/hoc";
import { Content } from "core/layouts";
import { FacilityOrderTemplateNewFlowClinicalEdit } from "application/facility-order-new-flow-clinical/components";
import { PatientInformationBarNewFlow } from "application/facility-order-new-flow/components";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { toDate } from "core/utils";
import { DropDownButton, DropDownButtonItem, Button } from "@progress/kendo-react-buttons";

const FacilityOrderPatientNewFlowClinicalEditTemplate = function ({ facilityOrderPatientNewFlowClinicalEditViewStore, disabled, disabledSendOrder }) {
	const {
		items,
		contentLoading,
		patient,
		isNewPatient,
		inactiveOptionStore,
		inactiveOptionStoreId,
		selectedStatusAbrv,
		openInsuranceInformation,
		facilityOrderPatient,
		facilityOrderPatientNote,
		updateFacilityOrderPatient,
		openFacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal,
		facilityOrderTemplateStores,
		changeInsuranceInfo,
		insuranceInfo,
		openFacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal,
		openFacilityOrderPatientNewFlowInsuranceEditModal,
		openFacilityOrderPatientNewFlowUSIntakeInsuranceInfoModal,
		disabledPatient,
		openFacilityOrderPatientNewFlowInsuranceNoteModal,
		openExtraSuppliesApprovalRequiredModal,
		oldTemplate,
		openFacilityOrderTemplateItemNewFlowActivatePatientModal,
		getSelectedInactiveOption,
		setInsuranceStatus,
		openFacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal,
		showPreviousFlag,
		isMasterPatient,
		importFacilityOrderTemplates,
		isImportAllowed,
		facilityOrder,
	} = facilityOrderPatientNewFlowClinicalEditViewStore;

	const handleDropDownInsuranceItemsOnClick = async (e) => {
		if (e.item.text === "No changes") {
			setInsuranceStatus("no-change")
		}
		else if (e.item.text === "Change/Review") {
			setInsuranceStatus("change", true)
		}
	}

	const anyHistory = () => {
		return selectedStatusAbrv === "in-progress" && !isNewPatient && (
			(oldTemplate && (patient.primaryInsurance != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.primaryInsurance : null) || patient.primaryPolicyNo != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.primaryPolicyNo : null)))
			|| (oldTemplate && ((oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.primaryInsurance) !== "Medicare" || patient.primaryInsurance !== "Medicare") && patient.inactiveMedicareNo != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.inactivePrimaryPolicyNo : null))
			|| (oldTemplate && (patient.secondaryInsurance != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.secondaryInsurance : null) || patient.secondaryPolicyNo != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.secondaryPolicyNo : null)))
			|| (oldTemplate && (!(oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.secondaryInsurance && oldTemplate.facilityOrderTemplateInitial.secondaryInsurance.includes("Medicaid")) || !patient.secondaryInsurance.includes("Medicaid")) && patient.inactiveMedicaidNo != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.inactiveSecondaryPolicyNo : null))
			|| (facilityOrderPatient && facilityOrderPatient.eligibilityStatusId != (facilityOrderPatient.facilityOrderPatientInitial ? facilityOrderPatient.facilityOrderPatientInitial.eligibilityStatusId : ""))
			|| (items && items.some(item => (item.templateId && (item.isPriorAuthNeeded ? true : false) != (item.facilityOrderTemplateInitial && item.facilityOrderTemplateInitial.isPriorAuthNeeded ? true : false))))
		)		
	}

	return (
		facilityOrderTemplateStores && facilityOrderTemplateStores.length > 0 ?
			<div className="card--tertiary u-mar--bottom--sml--alt">
				<Content loading={contentLoading}>
					<ReactTooltip positionStrategy="fixed" id="registerTip" place="bottom" />
					<ReactTooltip positionStrategy="fixed" id="patientStatusBarTip" place="top" />
					<div className={`card--tertiary__header ${selectedStatusAbrv === "discharge" ? "" : "card--tertiary__header--insurance"}`}>
						<div className="u-flex--default">
							<h4 className="card--tertiary__header__title">
								{patient && patient.lastName && `${patient.lastName}`}
								{patient && patient.lastName && patient.firstName && ', '}
								{patient && patient.firstName && `${patient.firstName}`}
							</h4>
							<PatientInformationBarNewFlow patient={patient} disabled={disabledSendOrder} role="Clinical" isNewPatient={isNewPatient} isMasterPatient={isMasterPatient} facilityOrder={facilityOrder}/>
							{
								isNewPatient && selectedStatusAbrv === "discharge" &&
								<div className="status status--sml status--success u-display--ib">
									New Patient
								</div>
							}
						</div>
						<div className="u-flex--default u-align--h--right">
							{
								selectedStatusAbrv === "discharge" &&
								<div className="u-mar--right--tny">
									<ReactTooltip positionStrategy="fixed" id="templateTip" place="bottom" />
									{isImportAllowed && <Button className="btn btn--icon--sml-med btn--light u-mar--right--xsml" icon="u-icon u-icon--sml u-icon--upload" onClick={() => importFacilityOrderTemplates()} disabled={disabled || disabledSendOrder || disabledPatient} data-tooltip-content="Import to Brightree" data-tooltip-id="templateTip" />}
									
								</div>
							}
						<BaasicButton
								className="btn btn--icon--sml-med btn--light is-plus u-mar--right--xsml"
								icon="u-icon u-icon--xmed u-icon--add-lined"
								label="Add Template"
								onlyIcon={true}
								onClick={() => { openExtraSuppliesApprovalRequiredModal(isMasterPatient) }}
								disabled={disabled || disabledSendOrder || disabledPatient}
							></BaasicButton>
							<div className={`${showPreviousFlag() && !disabledPatient ? "k-dropdown--status-indicator" : ""}  w--200--px u-align--h--right u-mar--left--xsml`}>
								<div className="k-dropdown--tooltip" data-tooltip-content={(showPreviousFlag() && !disabledPatient) ? `Previous: ${facilityOrderPatient.facilityOrderPatientInitial ? facilityOrderPatient.facilityOrderPatientInitial.activeStatus : ''}` : ''} data-tooltip-id={(showPreviousFlag() && !disabledPatient) ? "patientStatusBarTip" : ""}></div>
								<BaasicDropdown store={inactiveOptionStore} value={inactiveOptionStoreId} onChange={(e) => { openFacilityOrderTemplateItemNewFlowActivatePatientModal(e.value.id, true) }} disabled={disabled || disabledSendOrder || disabledPatient} />
							</div>
						</div>
					</div>
					{selectedStatusAbrv !== "discharge" &&
						<div className="card--tertiary__subheader btn--group__wrapper">
							<div className="card--tertiary__flex">
								<BaasicButton
									type='button'
									className="btn btn--base-plus btn--light btn--uppercase"
									label={facilityOrderPatient && facilityOrderPatient.eligibilityStatus ? facilityOrderPatient.eligibilityStatus.name : "Blank"}
									disabled={disabled || disabledSendOrder || disabledPatient}
									onClick={() => { openFacilityOrderPatientNewFlowInsuranceNoteModal("change", true) }}
								/>
								{facilityOrderPatient && facilityOrderPatient.eligibilityStatus && facilityOrderPatient.eligibilityStatus.name != "Eligible" &&
									<Button className="btn btn--link" icon="u-icon u-icon--med u-icon--us-note" onClick={() => openFacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal()} disabled={disabled || disabledSendOrder || disabledPatient} data-tooltip-content="Eligibility Status Note" data-tooltip-id="registerTip" />
								}
								{patient &&
									<div className="card--tertiary__data">
										<div>
											<div className="card--tertiary__data__item">
												<div>Primary:</div>
												<div className="type--color--primary type--wgt--semibold">{patient.primaryInsurance}</div>
												{patient.primaryPolicyNo &&
													<div>{patient.primaryPolicyNo}</div>
												}
											</div>
											{patient.primaryInsurance !== "Medicare" && patient.inactiveMedicareNo &&
												<div className="card--tertiary__data__item">
													<div>Inactive:</div>
													<div className="type--color--primary type--wgt--semibold">Medicare</div>
													{patient.inactiveMedicareNo &&
														<div>{patient.inactiveMedicareNo}</div>
													}
												</div>
											}
										</div>
										<div>
											<div className="card--tertiary__data__item">
												<div>Secondary:</div>
												<div className="type--color--primary type--wgt--semibold">{patient.secondaryInsurance}</div>
												{patient.secondaryPolicyNo &&
													<div>{patient.secondaryPolicyNo}</div>
												}
											</div>
											{!patient.secondaryInsurance.includes("Medicaid") && patient.inactiveMedicaidNo &&
												<div className="card--tertiary__data__item">
													<div>Inactive:</div>
													<div className="type--color--primary type--wgt--semibold">Medicaid</div>
													{patient.inactiveMedicaidNo &&
														<div>{patient.inactiveMedicaidNo}</div>
													}
												</div>
											}
										</div>
										{
											facilityOrderPatient.insuranceQuestion &&
											<div className="u-flex u-flex--default u-flex--gap--2">
												<div className="card--tertiary__header__divider"></div>
												<Button className="btn btn--status--red u-mar--left--xsml" icon="u-icon u-icon--med-lrg u-icon--us-question-note--red" onClick={() => { openFacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal() }} disabled={disabled} />
											</div>
										}
									</div>
								}
								<div className="u-flex u-flex--default u-align--h--right">
									<div className="btn--group">
										<ReactTooltip positionStrategy="fixed" id="templateTip" place="bottom" />
										<Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-edit" onClick={() => openFacilityOrderPatientNewFlowInsuranceEditModal()} disabled={disabled || disabledSendOrder || disabledPatient} data-tooltip-content="Edit Insurance" data-tooltip-id="templateTip" />
										{!facilityOrderPatient.insuranceQuestion  && <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-question-note-sh" onClick={() => openFacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal()} disabled={disabled || disabledPatient} data-tooltip-content="Insurance Question" data-tooltip-id="templateTip" /> }
										<Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-note" onClick={() => openFacilityOrderPatientNewFlowUSIntakeInsuranceInfoModal()} disabled={disabled || disabledSendOrder || disabledPatient} data-tooltip-content="Insurance Info Note" data-tooltip-id="templateTip" />
										<Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-history" onClick={() => openFacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal()} disabled={disabled || disabledPatient} data-tooltip-content="Change History" data-tooltip-id="templateTip" />
										<Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-insurance-external-link" onClick={() => openInsuranceInformation()} disabled={disabled || disabledPatient} data-tooltip-content="Brightree" data-tooltip-id="templateTip" />
										{isImportAllowed && <Button className="btn no-hover" icon="u-icon u-icon--sml u-icon--upload" onClick={() => importFacilityOrderTemplates()} disabled={disabled || disabledPatient} data-tooltip-content="Import to Brightree" data-tooltip-id="templateTip" />}
										<div className="btn--group__divider"></div>
									</div>
									{
										items && items.filter(fot => fot.isPriorAuthNeeded).length > 0 &&
										<BaasicButton
											type='button'
											className="btn btn--base-plus btn--light is-grey no-click"
											label={`PAR ${items.filter(fot => fot.isPriorAuthNeeded).length}/${items.length}`}
											disabled={disabled || disabledSendOrder}
										/>
									}

									{isNewPatient ?
										<div className={`card--tertiary__status--card ${disabled || disabledSendOrder ? "is-disabled" : "" }`}>
											<div className={`status--sqare__holder yellow`}>
												<div className="status--sqare__wrapper">
													<Button className="btn status--square btn--yellow" icon="u-icon u-icon--xsml u-icon--persons--yellow" onClick={() => setInsuranceStatus("change")} disabled={disabled || disabledSendOrder || disabledPatient}>NEW PATIENT</Button>
												</div>
											</div>
										</div>
										:
										<div className={`card--tertiary__status--card ${disabled || disabledSendOrder || disabledPatient ? "is-disabled" : "" }`}>
											<div className={`status--sqare__holder ${getSelectedInactiveOption("insurance") === "success" ? "success" : "warning"}`}>
												<div className="status--sqare__wrapper">
													<DropDownButton
														text={getSelectedInactiveOption("insurance") === "success" ? "NO CHANGES" : "CHANGES"}
														fillMode={"solid"}
														themeColor={"primary"}
														onItemClick={(e) => handleDropDownInsuranceItemsOnClick(e)}
														buttonClass={`btn btn--base btn--ghost k-dropdown-button--icons status--sqare ${getSelectedInactiveOption("insurance") === "success" ? "success" : "reload"}`}
														disabled={disabled || disabledSendOrder || disabledPatient}
														popupSettings={{
															animate: false,
															anchorAlign: { horizontal: "right", vertical: "bottom" },
															popupAlign: { horizontal: "right", vertical: "top" },
															popupClass: 'is-clean'
														}}
													>
														{(getSelectedInactiveOption("insurance") === "change" || (getSelectedInactiveOption("insurance") !== "success" && getSelectedInactiveOption("insurance") !== "change")) && <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--success" text="No changes" />}
														{(getSelectedInactiveOption("insurance") === "success" || (getSelectedInactiveOption("insurance") !== "success" && getSelectedInactiveOption("insurance") !== "change")) && <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--change" text="Change/Review" />}
													</DropDownButton>
												</div>
											</div>
										</div>
									}
								</div>
							</div>
							{facilityOrderPatient.insuranceInfo && <div className="c-message has-input c-message--note u-mar--top--sml">
								<i className="u-icon u-icon--sml u-icon--add-note" />
								<input
									className="input input--sml input--message u-flex--grow--1 type--sml"
									onClick={(e) => e.target.select()}
									onChange={(e) => { changeInsuranceInfo(e.target.value) }}
									onBlur={async () => { await updateFacilityOrderPatient(true) }}
									value={insuranceInfo}
									disabled={disabled || disabledSendOrder}
								/>
							</div>}
							{								
								(
									facilityOrderPatient && facilityOrderPatient.note
									|| anyHistory()								
								) &&
								<div className={`u-mar--top--lrg c-message ${!isNewPatient ? 'c-message--orange' : 'c-message--note--primary c-message--note--primary--tab'}`}>
									{facilityOrderPatient && facilityOrderPatient.note &&
										<div className={`has-input ${isNewPatient || !anyHistory() ? '' : 'c-message--has-border'} u-flex--default u-flex--gap--1 w--100`} >
											Note: <p style={{ fontWeight: "normal" }}>{facilityOrderPatientNote}</p>									
											<div className="u-align--h--right type--whitespace--nowrap">
												{
													facilityOrderPatient.effectiveDate &&
													<React.Fragment>Effective Date: {facilityOrderPatient.effectiveDate ? toDate(facilityOrderPatient.effectiveDate) : ""}</React.Fragment>
												}
											</div>
										</div>
									}
									{selectedStatusAbrv === "in-progress" && !isNewPatient && oldTemplate && (patient.primaryInsurance != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.primaryInsurance : null) || patient.primaryPolicyNo != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.primaryPolicyNo : null)) &&
										<div className="u-flex--default u-flex--gap--2 c-message--content">
											<p className="type--sml"><b>Primary Active changed</b></p>
											<label className="type--sml type--color--opaque"><b>{oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.primaryInsurance ? oldTemplate.facilityOrderTemplateInitial.primaryInsurance : "Empty"}</b></label>
											{oldTemplate.facilityOrderTemplateInitial && patient.primaryInsurance == oldTemplate.facilityOrderTemplateInitial.primaryInsurance && oldTemplate.facilityOrderTemplateInitial.primaryPolicyNo && <div className="badge badge--sml badge--primary--opaque badge--primary--opaque--green"> {oldTemplate.facilityOrderTemplateInitial.primaryPolicyNo} </div>}
											<p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
											<p className="type--sml"><b>{patient.primaryInsurance ? patient.primaryInsurance : "Empty"}</b></p>
											{patient.primaryInsurance == (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.primaryInsurance : null) && patient.primaryPolicyNo && <div className="badge badge--sml badge--primary--opaque badge--primary--opaque--green"> {patient.primaryPolicyNo} </div>}
										</div>
									}
									{selectedStatusAbrv === "in-progress" && !isNewPatient && oldTemplate && ((oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.primaryInsurance) !== "Medicare" || patient.primaryInsurance !== "Medicare") && patient.inactiveMedicareNo != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.inactivePrimaryPolicyNo : null) &&
										<div className="u-flex--default u-flex--gap--2 c-message--content">
											<p className="type--sml"><b>Primary Inactive changed</b></p>
											<label className="type--sml type--color--opaque"><b>{(oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.primaryInsurance) !== "Medicare" ? 'Medicare' : "Empty"}</b></label>
											{oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.inactivePrimaryPolicyNo && <div className="badge badge--sml badge--primary--opaque badge--primary--opaque--green"> {oldTemplate.facilityOrderTemplateInitial.inactivePrimaryPolicyNo} </div>}
											<p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
											<p className="type--sml"><b>{patient.primaryInsurance !== "Medicare" ? 'Medicare' : "Empty"} </b></p>
											{patient.inactiveMedicareNo && <div className="badge badge--sml badge--primary--opaque badge--primary--opaque--green"> {patient.inactiveMedicareNo} </div>}
										</div>
									}
									{selectedStatusAbrv === "in-progress" && !isNewPatient && oldTemplate && (patient.secondaryInsurance != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.secondaryInsurance : null) || patient.secondaryPolicyNo != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.secondaryPolicyNo : null)) &&
										<div className="u-flex--default u-flex--gap--2 c-message--content">
											<p className="type--sml"><b>Secondary Active changed</b></p>
											<label className="type--sml type--color--opaque"><b>{oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.secondaryInsurance ? oldTemplate.facilityOrderTemplateInitial.secondaryInsurance : "Empty"}</b></label>
											{oldTemplate.facilityOrderTemplateInitial && patient.secondaryInsurance == oldTemplate.facilityOrderTemplateInitial.secondaryInsurance && oldTemplate.facilityOrderTemplateInitial.secondaryPolicyNo && <div className="badge badge--sml badge--primary--opaque badge--primary--opaque--green"> {oldTemplate.facilityOrderTemplateInitial.secondaryPolicyNo} </div>}
											<p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
											<p className="type--sml"><b>{patient.secondaryInsurance ? patient.secondaryInsurance : "Empty"}</b></p>
											{patient.secondaryInsurance == (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.secondaryInsurance : null) && patient.secondaryPolicyNo && <div className="badge badge--sml badge--primary--opaque badge--primary--opaque--green"> {patient.secondaryPolicyNo} </div>}
										</div>
									}
                                    {selectedStatusAbrv === "in-progress" && !isNewPatient && oldTemplate && (!(oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.secondaryInsurance && oldTemplate.facilityOrderTemplateInitial.secondaryInsurance.includes("Medicaid")) || !patient.secondaryInsurance.includes("Medicaid")) && patient.inactiveMedicaidNo != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.inactiveSecondaryPolicyNo : null) &&										<div className="u-flex--default u-flex--gap--2 c-message--content">
											<p className="type--sml"><b>Secondary Inactive changed</b></p>
											<label className="type--sml type--color--opaque"><b>{!(oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.secondaryInsurance && oldTemplate.facilityOrderTemplateInitial.secondaryInsurance.includes("Medicaid")) ? 'Medicaid' : "Empty"} </b></label>
											{oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.inactiveSecondaryPolicyNo && <div className="badge badge--sml badge--primary--opaque badge--primary--opaque--green"> {oldTemplate.facilityOrderTemplateInitial.inactiveSecondaryPolicyNo} </div>}
											<p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
											<p className="type--sml"><b>{!patient.secondaryInsurance.includes("Medicaid") ? 'Medicaid' : 'Empty'}</b></p>
											{patient.inactiveMedicaidNo && <div className="badge badge--sml badge--primary--opaque badge--primary--opaque--green"> {patient.inactiveMedicaidNo} </div>}
										</div>
									}
									{selectedStatusAbrv === "in-progress" && !isNewPatient && facilityOrderPatient && facilityOrderPatient.eligibilityStatusId != (facilityOrderPatient.facilityOrderPatientInitial ? facilityOrderPatient.facilityOrderPatientInitial.eligibilityStatusId : "") &&
										<div className="u-flex--default u-flex--gap--2 c-message--content">
											<p className="type--sml"><b>Insurance status changed</b></p>
											<label className="type--sml type--color--opaque"><b>{facilityOrderPatient.facilityOrderPatientInitial && facilityOrderPatient.facilityOrderPatientInitial.eligibilityStatus ? facilityOrderPatient.facilityOrderPatientInitial.eligibilityStatus.name : "Empty"}</b></label>
											<p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
											<p className="type--sml"><b>{facilityOrderPatient.eligibilityStatus ? facilityOrderPatient.eligibilityStatus.name : "Empty"}</b></p>
										</div>
									}
									{selectedStatusAbrv === "in-progress" && !facilityOrderPatient.isNewPatient && 
										items && items.map(item => {
											return (item.templateId && (item.isPriorAuthNeeded ? true : false) != (item.facilityOrderTemplateInitial && item.facilityOrderTemplateInitial.isPriorAuthNeeded ? true : false) &&
												<div className="u-flex--default u-flex--gap--2 c-message--content">
													<p className="type--sml"><b> {`${item.subCategory.name} template ${item.templateId} PAR changed`}</b></p>
													<label className="type--sml type--color--opaque"><b>{item.facilityOrderTemplateInitial && item.facilityOrderTemplateInitial.isPriorAuthNeeded ? "TRUE" : "FALSE"}</b></label>
													<p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
													<p className="type--sml"><b>{item.isPriorAuthNeeded ? "TRUE" : "FALSE"}</b></p>
												</div>
											);
										})
									}
								</div>
							}
						</div>
					}
					<div className="card--tertiary__body">
						{
							facilityOrderTemplateStores.map(store => {
								return (
									store.item && store.item.id &&
									<FacilityOrderTemplateNewFlowClinicalEdit
										id={store.item.id}
										key={store.item.id}
										facilityOrderTemplateNewFlowClinicalEditViewStore={store}
										disabled={disabled || disabledPatient}
										disabledSendOrder={disabledSendOrder}
									/>
								);
							})
						}
					</div>
				</Content>
			</div>
			: <React.Fragment></React.Fragment>
	);
};

FacilityOrderPatientNewFlowClinicalEditTemplate.propTypes = {
	facilityOrderPatientNewFlowClinicalEditViewStore: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	disabledSendOrder: PropTypes.bool
};

export default defaultTemplate(FacilityOrderPatientNewFlowClinicalEditTemplate);